/* eslint-disable global-require */
import React from "react";
import { Custom } from "./TotalAmountStyle";

export default function ReferralMessage({ message }: { message: string }) {
  return (
    <>
      <Custom />
      <p
        style={{
          fontSize: "120%",
          color: "#1070b6",
          fontWeight: "bold",
          textAlign: "left",
          marginBottom: "0",
        }}
      >
        {message}
      </p>
    </>
  );
}
